import { create } from 'zustand';

import type { UserProfile } from '@shared/types/user';

interface AuthStore {
  user: UserProfile | null;
  isLoading: boolean;
  setUser: (user: UserProfile | null) => void;
  setLoading: (isLoading: boolean) => void;
  clearAuth: () => void;
  refreshUser: () => Promise<void>;
}

/**
 * Zustand store for authentication state
 * Manages user profile and loading state globally
 */
export const useAuthStore = create<AuthStore>((set, get) => ({
  user: null,
  isLoading: true,
  setUser: (user) => set({ user }),
  setLoading: (isLoading) => set({ isLoading }),
  clearAuth: () => set({ user: null, isLoading: false }),
  refreshUser: async () => {
    const { user } = get();
    if (user) {
      try {
        const { getUserProfile } = await import('@lib/firebase/firestore');
        const updatedProfile = await getUserProfile(user.id);
        set({ user: updatedProfile });
      } catch (error) {
        console.error('Error refreshing user:', error);
      }
    }
  },
}));

